export default "__VITE_ASSET__wohTPzPT__"